/**
 * Reconhece o número público de uma notificação extrajudicial nos dois formatos que convivem: a
 * sequência mensal antiga (`NOT-202609-000029`) e o sufixo aleatório em Crockford Base32 que a
 * substituiu (`NOT-26-4827KX`). Notificação antiga não é renumerada — o número está nos PDFs —,
 * então reconhecer só um dos formatos quebra metade dos links.
 *
 * @example isNumeroNotificacao('NOT-26-4827KX') // true
 */
export const isNumeroNotificacao = (valor: string): boolean =>
  /^NOT-(\d{6}-\d{6}|\d{2}-[0-9A-HJKMNP-TV-Z]{6})$/i.test(valor);
